<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 font-weight-bold">Dämmplatte</div>
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row">
        <div class="col-6 d-flex flex-column justify-content-between">
          <span class="d-block pb-2">Mineralwoll&shy;dämmplatte</span>
          <div
            class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row"
          >
            <button
              type="button"
              v-for="(item, index) in items.mineral"
              :key="index"
              :class="[
                'btn btn-sm btn-outline-filter',
                filterUiState('insulation', item.value),
              ]"
              v-on:click="selectValue(item.value)"
            >
              {{ item.title }}
            </button>
          </div>
        </div>
        <div class="col-6 d-flex flex-column justify-content-between">
          <span class="d-block pb-2">Holzfaser&shy;dämmplatte</span>
          <div
            class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row"
          >
            <button
              type="button"
              v-for="(item, index) in items.wood"
              :key="index"
              v-bind:item="item"
              :class="[
                'btn btn-sm btn-outline-filter',
                filterUiState('insulation', item.value),
              ]"
              v-on:click="selectValue(item.value)"
            >
              {{ item.title }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionInsulation',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      items: {
        mineral: [
          { title: '≥ 15 mm', value: 'm-15' },
          { title: '≥ 20 mm', value: 'm-20' },
          { title: '≥ 30 mm', value: 'm-30' },
          { title: '≥ 40 mm', value: 'm-40' }
        ],
        wood: [
          { title: '≥ 4 mm', value: 'w-4' },
          { title: '≥ 20 mm', value: 'w-20' },
          { title: '≥ 30 mm', value: 'w-30' },
          { title: '≥ 40 mm', value: 'w-40' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      let result = this.items.mineral.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.wood.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('insulation', value)

      const category = value === 'w-4' || value === 'w-20' || value === 'w-30' || value === 'w-40' ? 'Dämmung - Holzfaser­dämmplatte' : 'Dämmung - Mineralwoll­dämmplatte'

      this.$gtm.trackEvent({
        event: 'filter',
        category: category,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: Number(value.split('-')[1])
      })

      this.$store.dispatch('filter/setValue', {
        name: 'insulation',
        title: category + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
